import L from "leaflet";
import "leaflet/dist/leaflet.css";
import type { Feature, Geometry } from "geojson";

let map: L.Map | undefined;
let resultLayer: L.GeoJSON | undefined;

export function initMap(container: HTMLElement): L.Map {
  map = L.map(container, {
    zoomControl: true,
    attributionControl: true,
  }).setView([10.5061, -66.8792], 13);

  L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
    attribution: "&copy; OpenStreetMap &copy; CARTO",
    maxZoom: 19,
  }).addTo(map);

  requestAnimationFrame(() => map?.invalidateSize());
  return map;
}

function asFeature(geometry: Geometry): Feature {
  return { type: "Feature", properties: {}, geometry };
}

export function showGeoOnMap(
  feature: Feature,
  extras: Array<Feature | Geometry> = [],
) {
  if (!map) return;

  resultLayer?.remove();
  resultLayer = L.geoJSON(undefined, {
    style: {
      color: "#30d158",
      weight: 2,
      fillColor: "#30d158",
      fillOpacity: 0.22,
    },
    pointToLayer: (_geo, latlng) =>
      L.circleMarker(latlng, {
        radius: 7,
        color: "#0a84ff",
        fillColor: "#7dd3fc",
        fillOpacity: 0.95,
        weight: 2,
      }),
  }).addTo(map);

  for (const extra of extras) {
    const feat = extra.type === "Feature" ? extra : asFeature(extra);
    L.geoJSON(feat, {
      pointToLayer: (_geo, latlng) =>
        L.circleMarker(latlng, {
          radius: 5,
          color: "#f5f5f7",
          fillColor: "#0a84ff",
          fillOpacity: 1,
          weight: 2,
        }),
      style: {
        color: "#0a84ff",
        weight: 2,
        fillColor: "#0a84ff",
        fillOpacity: 0.08,
        dashArray: "4 4",
      },
    }).addTo(resultLayer);
  }

  L.geoJSON(feature, {
    style: {
      color: "#30d158",
      weight: 2,
      fillColor: "#30d158",
      fillOpacity: 0.28,
    },
    pointToLayer: (_geo, latlng) =>
      L.circleMarker(latlng, {
        radius: 8,
        color: "#30d158",
        fillColor: "#30d158",
        fillOpacity: 1,
        weight: 2,
      }),
  }).addTo(resultLayer);

  const bounds = resultLayer.getBounds();
  if (bounds.isValid()) {
    map.fitBounds(bounds.pad(0.35));
  }
}

export function invalidateMap() {
  map?.invalidateSize();
}
